import { createMuiTheme } from '@material-ui/core/styles';
import { palette, panelColors } from './palette';
import { tableOverrides } from './tableOverrides';

const theme = createMuiTheme({
    palette,
    typography: {
        useNextVariants: true,
        icon: {
            default: 30
        }
    },
    widths: {
        drawer: '25%'
    },
    overrides: {
        ...tableOverrides,
        // for dropdown menus in field settings side panel and '+' FAB dropdown
        MuiList: {
            root: {
                backgroundColor: palette.listBackground
            }
        },
        MuiFormHelperText: {
            root: {
                minHeight: 0
            }
        },
        MuiDialogActions: {
            root: {
                margin: '20px 25px'
            }
        },
        MuiChip: {
            root: {
                cursor: 'pointer'
            }
        },
        MuiExpansionPanel: {
            root: {
                borderBottom: `1px solid ${panelColors.light}`,
                boxShadow: 'none',
                '&:before': {
                    display: 'none'
                }
            }
        },
        MuiExpansionPanelSummary: {
            root: {
                '&:hover': {
                    background: palette.background.body
                }
            }
        }
    }
});

export default theme;
